export default __webpack_public_path__ + "static/media/img-slider-tspace-5.5f94890a.png";